module.exports = __webpack_public_path__ + "assets/icon_close.86c818ba.svg";